import InputNumber from 'antd/lib/input-number';
import React from 'react';
import { connectField, filterDOMProps } from 'uniforms';
import wrapField from './wrapField';

var noneIfNaN = function noneIfNaN(x) {
  return isNaN(x) ? undefined : x;
};

var Num = function Num(props) {
  return wrapField(props, React.createElement(InputNumber, Object.assign({
    disabled: props.disabled,
    id: props.id,
    max: props.max,
    min: props.min,
    name: props.name,
    onChange: function onChange(value) {
      return props.onChange(noneIfNaN(value));
    },
    placeholder: props.placeholder,
    ref: props.inputRef,
    step: props.step || (props.decimal ? 0.01 : 1),
    value: props.value,
    style: {
      width: '100%'
    }
  }, filterDOMProps(props))));
};

export default connectField(Num, {
  ensureValue: false
});